import type { DeepResearchConfidenceSummary, DeepResearchSource } from './types';

const ensureSection = (report: string, heading: string, body: string) => {
  if (report.toLowerCase().includes(`## ${heading.toLowerCase()}`)) {
    return report;
  }

  return `${report.trim()}\n\n## ${heading}\n${body.trim()}`.trim();
};

export function assembleFinalResearchReport(params: {
  reportDraft: string;
  confidence: DeepResearchConfidenceSummary;
  sources: DeepResearchSource[];
  limitations: string[];
}) {
  const { reportDraft, confidence, sources, limitations } = params;
  const topSources = sources.slice(0, 12);

  let report = reportDraft.trim();
  report = ensureSection(
    report,
    'Confidence summary',
    `- Overall confidence: **${confidence.label.toUpperCase()} (${confidence.score}/100)**\n- Drivers: ${confidence.factors.join('; ')}`
  );
  report = ensureSection(
    report,
    'Sources / citations',
    topSources.length > 0
      ? topSources
          .map((source) => `- [${source.id}] ${source.title}${source.url ? ` — ${source.url}` : ''}`)
          .join('\n')
      : '- No validated sources were retained.'
  );
  report = ensureSection(
    report,
    'Methodology / limitations note',
    limitations.length > 0
      ? limitations.map((item) => `- ${item}`).join('\n')
      : '- This report was generated by an automated multi-agent workflow with source validation, citation checks, and confidence scoring.'
  );

  return report;
}
